import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import colorUtils from '../../utils/color'

const useStyles = makeStyles(theme => {
  return {
    ul: {
      marginBlockStart: 0,
      padding: 0,
    },
  }
})

const ColorKey = ({
  settings,
}) => {
  const classes = useStyles()

  const ranges = colorUtils.getRanges({
    settings,
  })
  return (
    <Typography variant="caption">
      <ul className={ classes.ul }>
        {
          ranges.map((range, i) => {

            return (
              <li key={ i }>
                { range.id } = { range.min } to { range.max }
              </li>
            )
          })
        }
      </ul>
    </Typography>
  )
}

export default ColorKey